var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lesson-video-player"},[_c('video',{key:"complex",staticClass:"w-100",attrs:{"controls":"","crossorigin":"","id":"lesson-video-player"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }